export const description =
  "Certificats d'Économies d'Énergie secteur AGRI : primes pour isolation, équipements froid, variateurs, chauffage. Sans condition de revenus, cumulables avec PCAE et FranceAgriMer.";
